import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';
import modalMap from '../shared/components/modal-map/modal-map.view.html';
import modalProductComment from './product-comment-modal/product-comment-modal.view.html';
import modalCreateTemplate from './create-template-modal/create-template-modal.view.html';
import modalLogistic from './modal-logistic/modal-logistic.view.html';
import modalCartComment from './modal-comment-cart/modal-comment-cart.view.html';
import modalMora from './modal-mora/modal-mora.view.html';

let inject = [
  '$scope',
  'CartService',
  '$state',
  '$rootScope',
  'SharedService',
  '$uibModal',
  'ngAuthSettings',
  'SessionService',
  '$timeout',
  '$mdToast',
  '$mdDialog',
  '$filter',
  'DetailZoneService',
  '$stateParams'
];

class CartController {
  constructor($scope, CartService, $state, $rootScope, SharedService, $uibModal, ngAuthSettings, SessionService,
    $timeout, $mdToast, $mdDialog, $filter, DetailZoneService, $stateParams) {
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.ngAuthSettings = ngAuthSettings;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$filter = $filter;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.$mdToast = $mdToast;
    this.$mdDialog = $mdDialog;
    this.SessionService = SessionService;
    this.CartService = CartService;
    this.SharedService = SharedService;
    this.zoneService = DetailZoneService;
    this.loanding = false;
    this.orderDataForm = {
      country: '',
      state: '',
      city: '',
      shipping: 0,
      payment: '',
      comment: '',
      clientPriceList: '',
      payCondition: ''
    };
    this.quoteCartSeller = {
      realOrderInfo: {},
      realQuoteInfo: {}
    };
    this.orderDataForm.locationsByFastSearch = [];
    this.orderDataForm.locationSelected = false;
    this.orderDataForm.searchLocationtext = '';
    this.orderDataForm.loadingLocationsByFastSearh = false;
    this.orderDataForm.loadedLocationsByFastSearch = false;
    this.orderDataForm.errorLoadingLocationsByFastSearch = false;
    this.quoteCartSeller.subtotalItemsQuoteValueSeller = 0;
    this.quoteCartSeller.discountsItemsQuoteValueSeller = 0;
    this.quoteCartSeller.ivaItemsQuoteValueSeller = 0;
    this.quoteCartSeller.transportItemsQuoteValueSeller = 0;
    this.quoteCartSeller.totalItemsQuoteValueSeller = 0;
    this.pesoTotalCanasta = 0;
    this.cantidadTotalCanasta = 0;
    this.updatingCityLocation = false;
    this.updatedCityLocation = false;
    this.errorUpdatingCityLocation = false;
    this.pointsOfSaleData = [];
    this.pointOfSaleId = '';
    this.currentPointOfSale = '';
    this.loadingPointsOfSale = false;
    this.loadedPointsOfSale = false;
    this.savingPayMethodCart = false;
    this.errorUpdatingPayMethod = false;
    this.addingQuantityItemCart = false;
    this.addedQuantityItemCart = false;
    this.errorAddingQuantityItemtoCart = false;
    this.errorMessageAddingQuantityItemtoCart = '';
    this.errorMessagesAddingQuantityItemtoCart = '';
    this.coupon = {};
    this.coupon.savingCoupon = false;
    this.coupon.savedCoupon = false;
    this.coupon.validCoupon = false;
    this.orderDataForm.loadingCartInfo = true;
    this.orderDataForm.loadedCartInfo = false;
    this.loadedPayMethods = false;
    this.promiseDeliveryDays = 2;
    this.workingDay = 'AM';
    this.changeDeliveryDateOrder = true;
    this.deliveryDateOrder = '';
    this.deliveryDateOrderPickUp = '';
    this.maxDateAdapatative = new Date();
    this.minDateAdaptative = new Date();
    this.minDateEntregaAdaptative = new Date();
    this.maxDateAdapatative.setDate(this.maxDateAdapatative.getDate() + 30);
    this.orderDataForm.loadingStatusDebtsToPay = false;
    
    this.showOnlyCitiesInTransportRule = 0;

    this.cart = {};

    this.payConditions = {};
    this.modalidadesEntrega = {};

    this.modalidadEntrega = false;
    this.modalidadRecoge = false;
    this.servicioDescargue = false;
    this.transportePropio = true;
    this.transporteUltracem = false;

    this.debtsToPayResumen = {};
    this.dataComandResumen = {};
    this.showItemPriceModal = false;
    this.image = {};

    this.$rootScope.$on('onUpdateCart', (event, arg) => {
      this.updateCart();
    });

    this.$rootScope.$on('onUpdatePromise', (event, arg) => {
      this.promiseDeliveryDays = arg;
      this.updateCart();
      event.preventDefault();
    });

    this.$rootScope.$on('onUpdateDescargue', (event, arg) => {
      this.actualizarServicioDescargueCambioSucursal();
      event.preventDefault();
    });


    this.CartService.getMethodTransport().then(response => {



      this.showOnlyCitiesInTransportRule = (response.valor == 1) ? 0 : 1;

    });

    this.popup2 = {
      opened: false
    };

    this.popup3 = {
      opened: false
    };


    this.inicializarDatePiker();
    this.inicializarDatePikerPickUp();

  }

  $onInit() {
    let cartId = this.SessionService.get('cartId') || '';
    let userId = '';
    try {
      userId = this.shCtrl.globals.currentUser.userId;
    }
    catch (e) {
    }
    let clientPriceListName = '';
    try {
      clientPriceListName = this.SessionService.get('quoteCartSeller').clientPriceList;
    } catch (e) {
    }

    // Si Configuración -> Parámetros Generales -> ¿Ocultar ítems sin precio? es igual a false, responde automaticamente false
    this.CartService.checkItemsPriceByCart(cartId, userId, clientPriceListName, true, undefined, this.shCtrl.globals.currentClient.operatingCenter.id).then(checkResponse => {

      if(checkResponse.data.hasOwnProperty('finalArray')) {

        let arrayItemPriceCopy = checkResponse.data.finalArray.map((item) => {
          if(item.deleteFromCart) this.showItemPriceModal = true;
          return item;
        });
      }

      if(checkResponse.data.activeParameter && this.$stateParams.from === 'fromTemplates' && this.showItemPriceModal) {
        let options = {
          title: 'Notificación',
          isHtml: true,
          content: this.shCtrl.globalParams.cmsInfo.hasOwnProperty('items_precio_cero_validacion_modal_platillas') ? this.shCtrl.globalParams.cmsInfo.items_precio_cero_validacion_modal_platillas : 
          'Los productos sin precio no han sido cargados a la canasta',
          size: '',
          showBottonCancel: false, 
          textActionCancel: '',
          textAction: 'Aceptar'
        };
        this.messageResponse(options);
      }

      this.CartService.getCartResumeData(cartId, userId).then(response => {
        this.image =response.items;
      });

      this.CartService.getCart(cartId, userId, clientPriceListName, true, undefined, this.shCtrl.globals.currentClient.operatingCenter.id).then(response => {
        this.cart = response;
        this.shCtrl.cart = response;
        this.getAllCartOrderInfo();
        // Get the bill resume
        try {
          if(this.cart.id_medio_pago){
            this.orderDataForm.payment = parseInt(this.cart.id_medio_pago);
          }
  
          if (this.shCtrl.globals.currentClient.third) {
            this.getInfoBillfoldState();
          }
          if (this.shCtrl.params.modalidadesEntrega) {
            this.getModalidadesEntrega(this.cart);
          }
  
          if (this.cart.cartOrderData.promiseDeliveryDays) {
            this.promiseDeliveryDays = this.cart.cartOrderData.promiseDeliveryDays;
            this.inicializarDatePiker();
          } else {
            this.getPromesaEntrega();
          }
  
          if (this.cart.cartOrderData.workingHours) {
            this.workingDay = this.cart.cartOrderData.workingHours;
          }
  
          if (this.cart.cartOrderData.deliveryDateOrder) {
            this.changeDeliveryDateOrder = true;
            let dateParts  = this.cart.cartOrderData.deliveryDateOrder.split("-");
            let date = new Date(dateParts[0] + "/" + dateParts[1] + "/"+ dateParts[2]);
  
            date.setDate(date.getUTCDate());
            this.deliveryDateOrder = date;
          }
  
          if (this.cart.cartOrderData.deliveryDateOrderPickUp) {
            let dateParts  = this.cart.cartOrderData.deliveryDateOrderPickUp.split("-");
            let date = new Date(dateParts[0] + "/" + dateParts[1] + "/"+ dateParts[2]);
  
            date.setDate(date.getUTCDate());
            this.deliveryDateOrderPickUp = date;
          }

          if (!this.cart.cartOrderData.deliveryDateOrderPickUp && this.cart.cartOrderData.deliveryDay) {
              
          }

          // test
          if (this.cart.cartOrderData.deliveryDay
            || (!this.cart.cartOrderData.deliveryDateOrderPickUp && this.cart.cartOrderData.deliveryDay)) {
            let dateParts  = this.cart.cartOrderData.deliveryDay.split("-");
            let date = new Date(dateParts[0] + "/" + dateParts[1] + "/"+ dateParts[2]);
  
            date.setDate(date.getUTCDate());
            this.deliveryDateOrder = date;
            console.log('this.deliveryDateOrder asign', this.deliveryDateOrder);

            if(!this.cart.cartOrderData.deliveryDateOrderPickUp && this.cart.cartOrderData.deliveryDay) {
              this.deliveryDateOrderPickUp = date;
            }

          }

          /*actualizar condicion de pago*/
          try{
            let sellerId = this.shCtrl.globals.currentUser.sellerId;
          let userId = this.shCtrl.globals.currentUser.userId;
          let sucursalId = this.shCtrl.cart.cartTunnelData.branchOffice;
            this.actualizarCondicionPagoAutomatica();
          }catch(e){
            console.log(e);
          }
          if(this.cart.id_forma_pago){
            this.orderDataForm.payCondition = this.cart.id_forma_pago;
          }
  
          if(this.cart.cartAnotaciones){
            this.orderComment = this.cart.cartAnotaciones;
            this.orderDataForm.comment = this.cart.cartAnotaciones;
          }
  
        }
        catch (e) {
        }
      }).catch(() => {
        this.$state.go(this.ngAuthSettings.site.app.header.logo.url);
      });
  
      this.getDebtsToPayClient();
    });

  }

  open2() {
    this.popup2.opened = true;
  }

  open3() {
    this.popup3.opened = true;
  }

  inicializarDatePiker() {

    let maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 30);

    let minDate = new Date();
    let numDaysMin = this.promiseDeliveryDays;
    minDate.setDate(minDate.getDate() + numDaysMin);
    let minDateAdaptative = new Date();

    //Dias festivos - to-do
    this.CartService.verifyDaysFestivesBranchOfficePromise(this.cart.cartId).then(response => {
      if(!response.error){
        if(response.permiteCompraFeriado){
          minDate.setDate(minDate.getDate() + numDaysMin);

          // inicializamos el minimo en adaptativo con la promesa de entrega
          this.minDateEntregaAdaptative.setDate(minDateAdaptative.getUTCDate() + numDaysMin);
        }else{
          numDaysMin = numDaysMin + response.numeroDiasNoHabiles;
          minDate.setDate(minDate.getDate() + numDaysMin);

          // inicializamos el minimo en adaptativo con la promesa de entrega
          this.minDateEntregaAdaptative.setDate(minDateAdaptative.getUTCDate() + numDaysMin);
        }

      }
    }); 
    
    this.dateOptions = Object.assign({}, {
      dateDisabled: this.disabled,
      formatYear: 'yy',
      maxDate: (maxDate),
      minDate: (minDate),
      startingDay: 1
    });
  }

  inicializarDatePikerPickUp() {

    let maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 30);

    let minDate = new Date();
    minDate.setDate(minDate.getDate() + this.promiseDeliveryDays);

    this.dateOptionsPickUp = Object.assign({}, {
      dateDisabled: this.disabled,
      formatYear: 'yy',
      maxDate: (maxDate),
      minDate: (minDate),
      startingDay: 1
    }); 
  }

  disabled(data) {
    var date = data.date,
      mode = data.mode;
    return mode === 'day' && (date.getDay() === 8 || date.getDay() === 9);
  }


  decreaseProductQuantity(product) {

    if (product.quantityToAddFromCart > 1){
        product.quantityToAddFromCart-= (product.factorQuantity>0)?product.factorQuantity:1;
    }
    if(product.cantidad_minima>0 && product.quantityToAddFromCart < product.cantidad_minima){
        if(product.factorQuantity > product.cantidad_minima){
            product.quantityToAddFromCart=product.factorQuantity;
        }else{
            product.quantityToAddFromCart=product.cantidad_minima;
        }
    }else if(product.cantidad_minima<0 && product.quantityToAddFromCart < product.cantidad_minima){
        product.quantityToAddFromCart=1;
    }


    this.saveItemQuantity(product);
  }

  increaseProductQuantity(product) {
    //product.quantityToAddFromCart++;
    product.quantityToAddFromCart =  parseFloat(product.quantityToAddFromCart) + ((parseFloat(product.factorQuantity)>0)?parseFloat(product.factorQuantity):1);


    this.saveItemQuantity(product);
  }

  getAllCartOrderInfo() {
    this.orderDataForm.loadingCartInfo = true;
    this.orderDataForm.loadedCartIfno = false;
    let cart = angular.copy(this.shCtrl.cart);
    if (cart) {

      this.SessionService.getGlobals().then(globals => {

        let sellerId = globals.currentUser.sellerId;
        let userId = globals.currentUser.userId;
        let sucursalId = this.shCtrl.cart.cartTunnelData.branchOffice;
        let cartId = this.SessionService.get('cartId') || '';

        this.CartService.getPayMethods(sellerId, userId, sucursalId,cartId).then(response => {
          if (!this.orderDataForm.pointOfSaleId) {
            this.loadedPayMethods = true;
            this.payMethods = response;
            if (response.length === 1) {
              this.orderDataForm.payment = response[0].id;
            }
          }
          this.CartService.getPointsOfSale(this.shCtrl.cart.cartTunnelData.branchOffice).then(response2 => {
            if (!this.orderDataForm.pointOfSaleId) {
              this.loadedPointsOfSale = true;
              this.pointsOfSaleData = response2.operatingCenters;
            }
            this.$timeout(() => {
              // Set the default Point of Sale


              try {



              let pointOfSaleId = '';
              try {
                pointOfSaleId = this.shCtrl.cart.order.pointOfSale.id;
              } catch (e) {

              }

              if (pointOfSaleId) {
                this.orderDataForm.pointOfSaleId = pointOfSaleId.toString();
                this.setCurrentPointOfSale(this.orderDataForm.pointOfSaleId);
              }
              else if (this.pointsOfSaleData.length > 0) {
                this.orderDataForm.pointOfSaleId = this.pointsOfSaleData[0].id.toString();
                this.setCurrentPointOfSale(this.orderDataForm.pointOfSaleId);
              }

              if (!this.orderDataForm.shipping && this.shCtrl.cart.order.shippingId) {
                this.orderDataForm.shipping = this.shCtrl.cart.order.shippingId.toString();
              }
              
              if (!this.orderDataForm.payment && this.SessionService.get('tunnelPayMethod')) {

                let flag_payMethod = false;
                for (let i = 0; i < this.payMethods.length; i++) {
                  let patMethod = this.payMethods[i];
                  if(patMethod.id == this.SessionService.get('tunnelPayMethod')){
                    flag_payMethod = true;
                  }      
                }
                
                if(flag_payMethod){
                  this.orderDataForm.payment = this.SessionService.get('tunnelPayMethod');
                }else{
                  this.orderDataForm.payment = "";
                }
                
                //this.orderDataForm.payment = this.SessionService.get('tunnelPayMethod');
              }
              else if (this.payMethods.length === 1) {
                this.orderDataForm.payment = this.payMethods[0].id.toString();
              }
            } catch (e) {
            }
              // Set the city
              try {
                if (this.SessionService.get('tunnelCity')) {
                  this.orderDataForm.city = this.SessionService.get('tunnelCity').location.cityId;
                  this.orderDataForm.state = this.SessionService.get('tunnelCity').location.stateId;
                  this.orderDataForm.country = this.SessionService.get('tunnelCity').location.countryId;
                  this.orderDataForm.searchLocationtext = this.SessionService.get('tunnelCity').location.fullName;
                }
              }
              catch (e) { }
            }, 1000);
          }).catch(reason => {

          });
        }).catch(reason => {

        });

        this.CartService.getPayConditions(userId, cart.cartId).then(response => {
          this.payConditions = response;
          if(this.payConditions.length == 1){
            //console.log(this.payConditions);
            this.savePayConditionCart(this.payConditions[0].id);

          }
          //this.orderDataForm.payCondition = response[0].id;
        }).catch(reason => {

        });
      })


    }
    this.orderDataForm.loadingCartInfo = false;
    this.orderDataForm.loadedCartInfo = true;
  }

  getInfoBillfoldState() {

    try {
      this.loadingBillResume = true;
      let thirdDocumentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
      //let branchCode = this.shCtrl.globals.currentClient.operatingCenter.code;
      this.zoneService.getBriefcase(thirdDocumentNumber).then(billfoldResume => {
        this.billfoldResume = billfoldResume;
        this.loadingBillResume = false;
        this.loadedBillResume = true;
        this.lastUpdatedBillResume = this.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');

        this.updatePayMethodsByBillfold();
      })
        .catch(error => {
          this.loadingBillResume = false;
        });

    }
    catch (e) {
      // ...
    }
  }

  updatePayMethodsByBillfold() {
    let filterpayMethods = [];

    let flag_condicionar_metodospago = this.billfoldResume.FLAG_CONDICION_MEDIOSPAGO_MORA;

    if (flag_condicionar_metodospago) {
      for (let i = 0; i < this.payMethods.length; i++) {
        let patMethod = this.payMethods[i];


        if (this.billfoldResume.VLR_VENCIDO > 0) {
          if (patMethod.visible_cliente_mora) {
            filterpayMethods.push(patMethod);
          }
        } else {
          filterpayMethods.push(patMethod);
        }


      }
      this.payMethods = filterpayMethods;
    }
  }

  buyNow(form, allowGuestInTunnel) {

    let invalidItems = this.checkPriceItems(this.cart.items);
    let quantitiesBaske;
    let validateQuantities;

    /**
     * Se valida los productos permitidos para comprar por sucursal ULTRACEM
     */

    let cartId = this.SessionService.get('cartId') || '';
    let userId = '';
    let sucursalId = '';
    let validaMora = this.ngAuthSettings.site.info.company.validaMoraPagoPedidos;
    let validaVolumen = this.ngAuthSettings.site.info.company.validacionVolumenCompra;
    try {
      userId = this.shCtrl.globals.currentUser.userId;
      sucursalId = this.shCtrl.globals.currentClient.operatingCenter.id;
    }
    catch (e) {
    }
    
    this.CartService.validateProductBySucursal({ userId: userId, cartId: cartId, sucursalId: sucursalId, origen: "B2B" }).then(response => {

      if (response.error) {
        let options = {
          title: 'Su pedido no puede ser procesado',
          isHtml: true,
          content: response.message,
          size: '',
          showBottonCancel: false,
          textActionCancel: '',
          textAction: 'Aceptar'
        };
        return this.messageResponse(options);
      }

      this.CartService.getQuantitiesBasketB2b().then(response => {


        if (!response.error) {
          quantitiesBaske = response.quantities;
          validateQuantities = response.validateQuantities;
        }
        if (this.orderDataForm.payment) {
          this.SessionService.put('tunnelPayMethod', this.orderDataForm.payment);
        }

        if (this.orderDataForm.city) {
          this.SessionService.put('tunnelCity', {
            location: {
              cityId: this.orderDataForm.city,
              stateId: this.orderDataForm.state,
              countryId: this.orderDataForm.country,
              fullName: this.orderDataForm.searchLocationtext
            }
          });
        }


        if (allowGuestInTunnel === 'register') {
          this.$state.go('home.login');
          return;
        }
        this.$rootScope.allowGuestInTunnel = allowGuestInTunnel || 0;
        this.showAllCartErrors = false;
        
        if (form.$valid) {
          if (this.cart) {
            let itemsCanastaUsuario = this.cart.itemsCanastaUsuario;
            let quantitiesCartUser = this.countQuantitiesCartUser(itemsCanastaUsuario);
            let itemWithOutStock = this.cart.items.filter(value => {
              if (value.quantity > value.cantidad) {
                return value;
              }
            });
            if (itemWithOutStock.length) {
              let cartItemHtml = '';
              itemWithOutStock.forEach(val => {
                cartItemHtml += `
                    <li>
                      <strong>- Producto: </strong> ${val.name} -
                      <strong>Cantidad: </strong>${val.cantidad} Unidades
                    </li>`;
              });
              let mensaje = `
                  <span>Lo Sentimos, Algunos productos exceden la cantidad dispobible<strong>
                  <ul>
                    ${cartItemHtml}
                  </ul>
                  Por favor elimine el excedente.</span>`;
              let options = {
                title: 'Cantidad no disponible',
                isHtml: true,
                content: mensaje,
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
              };
              return this.messageResponse(options);
            }
            if (invalidItems) {
              let mensaje = this.shCtrl.globalParams.cmsInfo.CANASTA_ITEM_CERO;
              let options = {
                title: 'El pedido no puede ser procesado',
                isHtml: true,
                content: mensaje,
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
              };
              return this.messageResponse(options);
            }
            if (validateQuantities != undefined && validateQuantities > 0) {
              if (quantitiesBaske != undefined && quantitiesBaske > 0) {
                if (quantitiesCartUser < quantitiesBaske) {
                  let mensaje = `
                                  <span>
                                  Recuerda que para continuar con el proceso de compra cada pedido debe tener mínimo ${quantitiesBaske}
                                  unidades agregadas en la canasta.</span>`;
                  let options = {
                    title: 'El pedido no puede ser procesado',
                    isHtml: true,
                    content: mensaje,
                    size: '',
                    showBottonCancel: false,
                    textActionCancel: '',
                    textAction: 'Aceptar'
                  };
                  return this.messageResponse(options);
                }
              }
            }
            if (this.changeDeliveryDateOrder && this.deliveryDateOrder == '') {
              let mensaje = `
                              <span>
                              Para continuar con este proceso debes diligenciar los siguientes datos:
                              </span>
                              - Seleccione una fecha válida para hacer entrega de su pedido.`;
              let options = {
                title: 'FALTAN ALGUNOS DATOS POR DILIGENCIAR',
                isHtml: true,
                content: mensaje,
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
              };
              return this.messageResponse(options);
            }
          }
          if (this.cart.cartId) {
            this.savingOrderCart = true;
            this.savedOrderCart = false;
            this.errorSavingOrderCart = false;
            this.orderDataForm.cartId = this.cart.cartId;
            this.orderDataForm.userId = '';
            this.orderDataForm.sellerId = '';
            this.orderDataForm.origen = 'B2B';
            this.orderDataForm.workingDay = this.workingDay;
            // Verificamos si la modalidad seleccinada es entrega y guardamos la fecha
            if (this.deliveryDateOrder != null && this.deliveryDateOrder != '' && this.modalidadEntrega) {
              let fechaEntrega = this.deliveryDateOrder;
              let fechaEntregaFormat = fechaEntrega.getFullYear() + "/" + (fechaEntrega.getMonth() + 1) + "/" + fechaEntrega.getDate();
              this.orderDataForm.deliveryDateOrder = fechaEntregaFormat;
            } else {
              this.orderDataForm.deliveryDateOrder = null;
            }
            // Verificamos si la modalidad seleccinada es recoge y guardamos la fecha
            if(this.deliveryDateOrderPickUp != null && this.deliveryDateOrderPickUp != '' && this.modalidadRecoge){
              let fechaRecoge = this.deliveryDateOrderPickUp;
              let fechaRecogeFormat = fechaRecoge.getFullYear() + "/" + (fechaRecoge.getMonth() + 1) + "/" + fechaRecoge.getDate();
              this.orderDataForm.deliveryDateOrderPickUp = fechaRecogeFormat;
            } else{
              this.orderDataForm.deliveryDateOrderPickUp = null;
            }
            try {
              this.orderDataForm.userId = this.shCtrl.globals.currentUser.userId;
            }
            catch (e) {
            }
            try {
              this.orderDataForm.sellerId = this.shCtrl.globals.currentUser.sellerId;
            }
            catch (e) {
            }

            if(validaMora){
              this.savingOrderCart = false;

              // Si aplica la validacion de mora
              this.verificarModalMora(this.orderDataForm);
              // this.showModalMora(this.orderDataForm);
            } else if(validaVolumen){
              this.verificarReglaCobertura(this.orderDataForm);
            } else{
              this.guardarPedidoCanasta(this.orderDataForm);
            }
          }
        } else {
          
          this.showAllCartErrors = true;
          angular.forEach(form.$error.required, field => {
            field.$setDirty();
          });
          if (!this.orderForm.searchLocationtext) this.orderForm.searchLocationtext = {};
          if (!this.orderForm.payment) this.orderForm.payment = {};
          if (!this.orderForm.clientPriceList) this.orderForm.clientPriceList = {};
          let contentDynamic = '';

          if (this.orderForm.searchLocationtext.$invalid && !this.orderDataForm.city) {
            contentDynamic = `
                <li>
                  Seleccione la Ciudad.
                </li>`;
          }

          if (this.orderForm.payment.$invalid && !this.orderForm.payment.$pristine) {
            contentDynamic += `
                <li>
                  Seleccione el medio de pago.
                </li>`;
          }
          if (this.orderForm.clientPriceList.$invalid && !this.orderForm.clientPriceList.$pristine) {
            contentDynamic += `
                <li>
                  Seleccione la lista de precios a aplicar al cliente.
                </li>`;
          }
          if (this.orderForm.payCondition.$invalid && !this.orderForm.payCondition.$pristine) {
            contentDynamic += `
                <li>
                  Seleccione la condicion de pago.
                </li>`;
          }

          /**
           * Se validada modalidades de entrega de la tienda personalizadas
           */

          if (this.shCtrl.params.modalidadesEntrega) {

            if (this.orderForm.recogeEntrega.$invalid && !this.orderForm.recogeEntrega.$pristine && this.orderForm.entregaDomicilio.$invalid && !this.orderForm.entregaDomicilio.$pristine) {
              contentDynamic += `
                  <li>
                    Seleccione la modalidad de entrega.
                  </li>`;
            }

            if (this.modalidadRecoge) {
              // ultracem validation 
              // if (this.orderForm.transportePropio.$invalid && !this.orderForm.transportePropio.$pristine && this.orderForm.transporteUltracem.$invalid && !this.orderForm.transporteUltracem.$pristine) {
              //   contentDynamic += `
              //     <li>
              //       Seleccione el tipo de transporte para reclamar su pedido.
              //     </li>`;
              // }

              if(this.orderForm.deliveryDateOrderPickUp.$invalid){
                contentDynamic += `
                  <li>
                  Seleccione la fecha programada para recoger el pedido.
                  </li>`;
              }

            }
            
            if (this.entregaDomicilio) {

            }

            try {
              if (this.orderForm.deliveryDateOrder.$invalid && !this.orderForm.deliveryDateOrder.$pristine) {
                contentDynamic += `
                <li>
                  Seleccione la fecha programada de entrega del pedido.
                </li>`;
              }

            } catch (e) {
               console.log("Error:", e);
            }

          }

          let options = {
            title: 'Faltan algunos datos por diligenciar...',
            isHtml: true,
            content: `
                <div>
                  <p>
                    Para continuar con este proceso debes diligenciar los siguientes datos:
                  </p>
                  <ul style="margin-top: 10px;list-style: inherit;margin-left: 30px;">
                    ${contentDynamic}
                  </ul>
                </div>
              `,
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar'
          };
          
          this.messageResponse(options);
        }
      });

    }).catch(reason => {

      let options = {
        title: '',
        isHtml: false,
        content: 'Ha ocurrido un error al actualizar el carrito',
        size: '',
        showBottonCancel: false,
        textActionCancel: '',
        textAction: 'Aceptar'
      };
      return this.messageResponse(options);
    });
  }

  showProductComment(item) {
    let modal_options = this.$uibModal.open({
      animation: true,
      template: modalProductComment,
      controller: 'ProductCommentModalController',
      controllerAs: 'mdCtrl',
      size: '',
      resolve: {
        modalOptions: () => item
      }
    });
    modal_options.result.then(() => {

    }).catch(reason => {

    });
  }

  guardarPedidoCanasta(orderDataForm){
    this.CartService.saveCartOrderData(orderDataForm).then(response => {
      this.savingOrderCart = false;
      if (!response.error) {
        this.savedOrderCart = true;
        this.shCtrl.globals.currentUser.city = orderDataForm.city;
        this.SessionService.put("currentUser", this.shCtrl.globals.currentUser);
        orderDataForm.comment = '';
        this.$state.go('home.tunnel');
      } else {
        let errorMessageSavingOrderCart = response.message;
        this.errorSavingOrderCart = true;
        let messageTitle = response.errorCode === 'EVMP' ? 'El pedido no puede ser procesado' : 'Debes diligenciar algunos datos aún...';
        let options = {
          title: messageTitle,
          isHtml: true,
          content: errorMessageSavingOrderCart,
          size: '',
          showBottonCancel: false,
          textActionCancel: '',
          textAction: 'Aceptar'
        };
        this.messageResponse(options);
      }
    }).catch(reason => {
      this.savingOrderCart = false;
      this.savedOrderCart = false;
      this.errorSavingOrderCart = true;
      let options = {
        title: '',
        isHtml: false,
        content: 'Ha ocurrido un error al actualizar la informacion del carrito',
        size: '',
        showBottonCancel: false,
        textActionCancel: '',
        textAction: 'Aceptar'
      };
      this.messageResponse(options);
    });

  }

  getLocationsByFastSearch(searchLocationText) {
    this.orderDataForm.locationSelected = false;
    this.orderDataForm.locationsByFastSearch = [];
    this.orderDataForm.locationSelected = false;
    this.orderDataForm.country = '';
    this.orderDataForm.state = '';
    this.orderDataForm.city = '';
    this.orderDataForm.loadingLocationsByFastSearh = false;
    this.orderDataForm.loadedLocationsByFastSearch = false;
    this.orderDataForm.errorLoadingLocationsByFastSearch = false;
    if (searchLocationText.length > 3) {
      this.orderDataForm.loadingLocationsByFastSearh = true;
      this.CartService.locationBySearchText({
        'searchText': searchLocationText,
        'showOnlyValidCountries': 1,
        'showOnlyCitiesInTransportRule': this.showOnlyCitiesInTransportRule
      }).then(response => {
        this.orderDataForm.loadingLocationsByFastSearh = false;
        this.orderDataForm.loadedLocationsByFastSearch = true;
        this.orderDataForm.locationsByFastSearch = response;
      }).catch(reason => {
        this.orderDataForm.loadingLocationsByFastSearh = false;
        this.orderDataForm.loadedLocationsByFastSearch = true;
        this.orderDataForm.errorLoadingLocationsByFastSearch = true;
      });
    }
  }

  setLocationCity(location) {
    this.orderDataForm.country = location.countryId;
    this.orderDataForm.state = location.stateId;
    this.orderDataForm.city = location.cityId;

    this.orderDataForm.locationSelected = true;
    this.orderDataForm.searchLocationtext = location.cityName + ', ' +
      location.stateName + ' - ' +
      location.countryName;
    this.updateCityLocation();
  }

  updateValuesQuoteSeller() {
    if (!this.orderDataForm.clientPriceList) {
      try {
        this.orderDataForm.clientPriceList = this.SessionService.get('quoteCartSeller').clientPriceList;
      }
      catch (e) {
      }

      if (!this.orderDataForm.clientPriceList) {
        this.orderDataForm.clientPriceList = 'client';
      }
    }
    this.quoteCartSeller.subtotalItemsQuoteValueSeller = 0;
    this.quoteCartSeller.ivaItemsQuoteValueSeller = 0;
    this.quoteCartSeller.discountsItemsQuoteValueSeller = 0;
    this.quoteCartSeller.transportItemsQuoteValueSeller = 0;
    this.quoteCartSeller.totalItemsQuoteValueSeller = 0;

    let realOrderInfo = {
      subtotal: 0,
      iva: 0,
      discount: 0,
      transport: 0,
      total: 0
    };

    let realQuoteInfo = {
      subtotal: 0,
      iva: 0,
      discount: 0,
      transport: 0,
      total: 0
    };
    if (this.shCtrl.globals.currentUser.isSeller) {
      // Se actualiza la informacion de los precios
      let itemsQuoteCartSeller = [];
      let priceListName = this.orderDataForm.clientPriceList;

      let subtotal = 0;
      let taxes = 0;
      let discounts = 0;
      let total = 0;
      this.cart.items.forEach((item, key) => {
        try {
          // Item data
          let itemId = item.id;
          let itemQuantity = item.quantity;
          let itemUnitValue = item.priceItemQuoteSeller;
          let itemQuantityValue = item.quantity * item.priceItemQuoteSeller;
          let itemTaxPercent = item.ivaPercentageQuoteSeller;
          let itemDiscountPercent = item.discountPercentageItemQuoteSeller;
          // Some verifications
          if (isNaN(itemDiscountPercent) || itemDiscountPercent < 0 || itemDiscountPercent > 100) {
            item.discountPercentageItemQuoteSeller = 0;
            itemDiscountPercent = 0
          }
          else if (priceListName === 'client' && itemDiscountPercent > item.maxDiscount) {
            item.discountPercentageItemQuoteSeller = item.maxDiscount;
            itemDiscountPercent = item.maxDiscount;
          }
          else if (priceListName === 'cost' && itemDiscountPercent > 100) {
            item.discountPercentageItemQuoteSeller = 100;
            itemDiscountPercent = 100;
          }

          // Item values
          let itemSubtotal = itemQuantityValue;
          let itemDiscount = 0;

          if (priceListName === 'client') {
            itemDiscount = itemQuantityValue * itemDiscountPercent / 100;
          }
          if (priceListName === 'cost') {
            itemDiscount = itemQuantityValue / ((100 - itemDiscountPercent) / 100);
            itemDiscount = itemDiscount - itemQuantityValue;
          }
          // Discount or Profit?
          let itemQuantityValueWithDiscount = 0;
          if (priceListName === 'client') {
            itemQuantityValueWithDiscount = itemQuantityValue - itemDiscount;
          }
          if (priceListName === 'cost') {
            itemQuantityValueWithDiscount = itemQuantityValue + itemDiscount;
          }
          let itemTax = itemQuantityValueWithDiscount * itemTaxPercent / 100;
          let itemTotal = itemQuantityValueWithDiscount + itemTax;

          // Totals
          subtotal += itemQuantityValue;
          discounts += itemDiscount;
          taxes += itemTax;
          total += itemTotal;

          // Update the item total model
          this.cart.items[key].totalItemCartSeller = itemTotal;

          // ========================================================================================================================
          // Real quote values
          // ========================================================================================================================
          if (item.quote) {
            realQuoteInfo.subtotal += itemQuantityValue;
            realQuoteInfo.iva += itemTax;
            realQuoteInfo.discount += itemDiscount;
            if (priceListName === 'client') {
              realQuoteInfo.total = realQuoteInfo.subtotal - realQuoteInfo.discount + realQuoteInfo.iva;
            }
            else if (priceListName === 'cost') {
              realQuoteInfo.total = realQuoteInfo.subtotal + realQuoteInfo.discount + realQuoteInfo.iva;
            }
          }
          // ========================================================================================================================
          // Real order values
          // ========================================================================================================================
          else {
            realOrderInfo.subtotal += itemQuantityValue;
            realOrderInfo.iva += itemTax;
            realOrderInfo.discount += itemDiscount;

            if (priceListName === 'client') {
              realOrderInfo.total = realOrderInfo.subtotal + realOrderInfo.iva - realOrderInfo.discount;
            }
            else if (priceListName === 'cost') {
              realOrderInfo.total = realOrderInfo.subtotal + realOrderInfo.iva + realOrderInfo.discount;
            }
          }

          // ========================================================================================================================
          // Push data to the cart seller object
          // ========================================================================================================================
          itemsQuoteCartSeller.push({
            id: item.id,
            priceItemQuoteSeller: itemUnitValue,
            ivaPercentageQuoteSeller: itemTaxPercent,
            discountPercentageItemQuoteSeller: itemDiscountPercent,
            discountValueItemQuoteSeller: itemDiscount
          });
        }
        catch (e) {
          let options2 = {
            title: '',
            isHtml: false,
            content: e,
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar'
          };
          this.messageResponse(options);
        }

        try {
          // Update the model
          this.quoteCartSeller.subtotalItemsQuoteValueSeller = subtotal;
          this.quoteCartSeller.ivaItemsQuoteValueSeller = taxes;
          this.quoteCartSeller.discountsItemsQuoteValueSeller = discounts;
          this.quoteCartSeller.transportItemsQuoteValueSeller = this.cart.cartTransports;
          this.quoteCartSeller.totalItemsQuoteValueSeller = total + this.cart.cartTransports;

          this.quoteCartSeller.realOrderInfo.transport = this.cart.cartTransports;
          this.quoteCartSeller.realOrderInfo.total += +this.cart.cartTransports;
          this.quoteCartSeller.realOrderInfo = realOrderInfo;

          this.quoteCartSeller.realQuoteInfo.transport = this.cart.cartTransports;
          this.quoteCartSeller.realQuoteInfo.total += +this.cart.cartTransports;
          this.quoteCartSeller.realQuoteInfo = realQuoteInfo;
          // save data state to cookie
          this.SessionService.put('quoteCartSeller', {
            clientPriceList: priceListName,
            itemsQuoteCartSeller: itemsQuoteCartSeller,
            subtotalItemsQuoteValueSeller: subtotal,
            ivaItemsQuoteValueSeller: taxes,
            discountsItemsQuoteValueSeller: discounts,
            totalItemsQuoteValueSeller: this.quoteCartSeller.totalItemsQuoteValueSeller,
            realOrderInfo: realOrderInfo,
            realQuoteInfo: realQuoteInfo
          });
        }
        catch (e) {
          let options = {
            title: '',
            isHtml: false,
            content: e,
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar'
          };
          this.messageResponse(options);
        }

      });
    }
    this.updateCart();
  }

  setCurrentPointOfSale(pointOfSaleId) {
    this.pointsOfSaleData.forEach(pointOfSale => {
      if (pointOfSale.id === pointOfSaleId) {
        this.currentPointOfSale = pointOfSale;
      }
    });
  }

  savePayMethodCart(payMethodId) {
    if (payMethodId) {
      this.savingPayMethodCart = true;
      this.errorUpdatingPayMethod = false;
      let data = {
        'cartId': this.cart.cartId,
        'payMethodId': payMethodId
      };
      this.CartService.updatePayMethod(data).then(response => {
        if (!response.error) {
          this.savingPayMethodCart = false;
          this.updateCart();
        }
        else {
          let options = {
            title: 'No es posible asignar el medio de pago',
            isHtml: true,
            content: response.message,
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar'
          };
          this.messageResponse(options);
          this.updateCart();
          this.savingPayMethodCart = false;
          this.errorUpdatingPayMethod = true;

          let flag_payMethod = false;
          for (let i = 0; i < this.payMethods.length; i++) {
            let patMethod = this.payMethods[i];
            if(patMethod.id == this.cart.id_medio_pago){
              flag_payMethod = true;
            }      
          }
          
          if(flag_payMethod){
            this.orderDataForm.payment = this.cart.id_medio_pago;
          }else{
            this.orderDataForm.payment = "";
          }
          
        }
      }).catch(reason => {
        this.savingPayMethodCart = false;
        this.errorUpdatingPayMethod = true;
      });
    }
  }

  changeLogisticService(value) {
    if (!value) {
      this.selectGuestUser();
    } else {
      this.guestUser = {};
    }
  };

  selectGuestUser() {
    let modalInstance = this.$uibModal.open({
      animation: true,
      backdrop: 'static',
      template: modalLogistic,
      controller: 'GuestUserController',
      controllerAs: 'mdCtrl',
      resolve: {
        optionsModal: () => {
          return this.guestUser;
        }
      }
    });
    modalInstance.result.then(resultUser => {
      this.guestUser = resultUser;
    }).catch(errModal => {
      this.isLogisticService = true;
    });
  }

  saveDiscountCoupon(code) {
    this.coupon.savingCoupon = true;
    this.coupon.savedCoupon = false;
    if (code === 'DESC14') {
      this.$timeout(() => {
        this.coupon.savingCoupon = false;
        this.coupon.couponSaved = true;

        this.coupon.validCoupon = true;
        this.coupon.couponValue = 10000;
      }, 3000);
    }
    else {
      this.$timeout(() => {
        this.coupon.discountCoupon = '';

        this.coupon.savingCoupon = false;
        this.coupon.couponSaved = true;

        this.coupon.validCoupon = false;
        this.coupon.couponValue = 0;
      }, 3000);
    }
  }

  updateCityLocation() {
    let cityLocationId = this.orderDataForm.city;
    this.updatingCityLocation = true;
    this.updatedCityLocation = false;
    this.errorUpdatingCityLocation = false;
    if (this.cart.cartId && cityLocationId) {
      this.CartService.updateCityLocation({
        'cartId': this.cart.cartId,
        'cityLocationId': cityLocationId
      }).then(response => {
        this.updatingCityLocation = false;
        this.updatedCityLocation = false;
        this.updateCart();
        if (response.error) {
          this.errorUpdatingCityLocation = true;
        }
      }).catch(reason => {
        this.updatingCityLocation = false;
        this.updatedCityLocation = true;
        this.errorUpdatingCityLocation = true;
      });

    }
  }

  saveItemQuantity(product) {

    product.addingQuantityItemCart = true;
    this.addingQuantityItemCart = true;
    this.addedQuantityItemCart = false;
    this.errorAddingQuantityItemtoCart = false;
    this.errorMessageAddingQuantityItemtoCart = '';
    this.errorMessagesAddingQuantityItemtoCart = '';
    let quantityAmount = angular.copy(product.quantityToAddFromCart);

    if (isNaN(product.quantityToAddFromCart) || product.quantityToAddFromCart < 1) {
      product.quantityToAddFromCart = product.quantity;

    }


    let validation = this.SessionService.validateFactorItems(product.quantityToAddFromCart, product);

    if (validation.error) {

      let options = {
        title: '',
        isHtml: true,
        content: validation.message,
        size: '',
        showBottonCancel: false,
        textActionCancel: '',
        textAction: 'Aceptar'
      };
      this.messageResponse(options);

      product.addingQuantityItemCart = false;
      this.addingQuantityItemCart = false;
      return;
    }

    if (product.quantity !== product.quantityToAddFromCart) {
      /* Si la cantidad a agregar del producto es mayor a la cantidad disponible del mismo le indica al
       * usuario que hacer al respecto */
      // if (quantity > product.cantidad){
      //   if (product.quantityToAddFromCart > product.cantidad) {

      //       let userId = '';
      //       try {
      //           userId = this.shCtrl.globals.currentUser.userId;
      //       }
      //       catch (e) {
      //       }
      //       this.CartService.updateItemsNotAvailable(product, quantityAmount, userId, this.cart.cartId);
      //       let mensaje = `
      // <span>Lo Sentimos, El producto <strong> ${product.name} </strong>
      // no está disponible en la cantidad solicitada. La existencia actual de este producto es
      // <strong>${product.cantidad}</strong> Unidades Hola Pruebas</span>`;
      //       product.quantityToAddFromCart = product.quantity;
      //       let options = {
      //           title: 'Cantidad no disponible',
      //           isHtml: true,
      //           content: mensaje,
      //           size: '',
      //           showBottonCancel: false,
      //           textActionCancel: '',
      //           textAction: 'Aceptar'
      //       };
      //       product.addingQuantityItemCart = false;
      //       return this.messageResponse(options);

      //   }

      let data = {
        'cartId': this.cart.cartId,
        'productId': product.id,
        'productQuantity': product.quantityToAddFromCart
      };

      if (this.cart.cartId) {
        this.CartService.updateQuantityItemCart(data).then(response => {
          this.addingQuantityItemCart = false;

          if (!response.error) {
            product.addingQuantityItemCart = true;
            this.updateCart();
            if(!response.pesoValidoBodega ){
              this.cambiarSucursalVolumenItems(this.cart);
            }
            if(!response.pesoMinimoValidoBodega){
              this.asignarSucursalPrincipal(this.cart.cartId)
            }
          }

          else {
            if (response.agotado) {
              let userId = '';
              try {
                userId = this.shCtrl.globals.currentUser.userId;
              }
              catch (e) {
              }
              product.cantidad = response.itemStock;
              console.log('cart 1 ->'+this.cart.cartId);
              this.CartService.updateItemsNotAvailable(product, product.quantityToAddFromCart, userId, this.cart.cartId);
            }


            // let userId = '';
            // try {
            //   userId = this.shCtrl.globals.currentUser.userId;
            // }
            // catch (e) {
            // }
            // this.CartService.updateItemsNotAvailable(product,product.quantityToAddFromCart,userId, this.cart.cartId);


            this.errorMessageAddingQuantityItemtoCart = response.message;
            product.quantityToAddFromCart = product.quantity;
            if (response.error) {
              this.errorAddingQuantityItemtoCart = true;
            }

            if (__env.adaptative) {
              this.errorAddingQuantityItemtoCart = true;
              this.messageMaterial(response.message);
             }

          }
          product.addingQuantityItemCart = false; 
          
        }).catch(reason => {
          this.addingQuantityItemCart = false;
          product.addingQuantityItemCart = false;
          product.quantityToAddFromCart = product.quantity;
          let options = {
            title: '',
            isHtml: false,
            content: 'Ha ocurrido un error al actualizar el carrito',
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar'
          };
          this.messageResponse(options);
        });
      }
    }
    else {
      this.addingQuantityItemCart = false;
      product.quantityToAddFromCart = product.quantity;
      product.addingQuantityItemCart = false;
    }

  };

  createTemplate() {
    let options = {
      globals: this.shCtrl.globals
    };
    let modal_options = this.$uibModal.open({
      animation: true,
      template: modalCreateTemplate,
      controller: 'CreateTemplateModalController',
      controllerAs: 'mdCtrl',
      size: '',
      resolve: {
        modalOptions: () => options
      }
    });
    modal_options.result.then(() => {

    }).catch(reason => {

    });
  }

  calcularTotales() {
    this.pesoTotalCanasta = 0;
    this.cantidadTotalCanasta = 0;
    this.cart.order.totalPesoItems = 0;
    this.cart.order.cantidadTotalCanasta = 0;
    this.cart.items.forEach(item => {
      this.pesoTotalCanasta += item.quantityToAddFromCart * item.peso.embalaje;
      this.cantidadTotalCanasta += item.quantityToAddFromCart;
      this.cart.order.totalPesoItems += item.quantityToAddFromCart * item.peso.embalaje;
      this.cart.order.cantidadTotalCanasta += item.quantityToAddFromCart;
    });
  }

  setCartSellerAction(form) {
    if (form.$valid) {
      let userIsLogged = false;
      try {
        userIsLogged = this.shCtrl.globals.currentUser.isLogged;
      }
      catch (e) {

      }
      // ===========================================================================================================
      // Logged client
      // ===========================================================================================================
      if (userIsLogged) {
        if (this.orderDataForm.quoteCartSellerAction === 'quote') {
          this.showModalCartSeller();
        }
        else if (this.orderDataForm.quoteCartSellerAction === 'order') {

          // If there is no client selected
          if (this.shCtrl.globals.currentUser.userId === this.shCtrl.globals.currentUser.sellerId) {
            this.showModalCartSeller();
          }
          else {
            this.buyNow(form);
          }
        }
      }
      else {
        this.showModalCartSeller();
      }
    }
    else {
      this.showAllCartErrors = true;

      angular.forEach(form.$error.required, field => {
        field.$setDirty();
      });
    }
  }

  showModalCartSeller() {
    // Always open the step 1

    // Validate the third number to restart all the info
    // let thirdNumberIb = $('#modalQuoteSeller #sellerQuoteAttendantDocumentNumber').val();
    // if (thirdNumberIb) {
    //   this.validateNumberIdUnused(thirdNumberIb);
    // }
  };

  openCartComment() {
    let options = {
      comment: this.orderComment
    };
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalCartComment,
      controller: 'CommentCartModalController',
      controllerAs: 'mdCtrl',
      size: '',
      resolve: {
        modalOptions: () => options
      }
    });
    modalInstance.result.then(comment => {
      this.orderDataForm.comment = comment;
      this.orderComment = comment;
    }).catch(reason => {

    });
  }

  removeItemFromCart(product) {
    if (__env.adaptative) {
      var that = this;
      var confirm = this.$mdDialog.confirm()
        .title('Eliminar producto ' + product.name)
        .textContent('¿En realidad desea eliminar del carrito el producto ' + product.name + '?')
        .ok('Aceptar')
        .cancel('Cancelar');

      this.$mdDialog.show(confirm).then(function () {
        that.confirmRemoveItem(product.id, product);
      }, function () {
        console.log("cancel");
      });
    } else {
      let options = {
        title: `ELIMINAR PRODUCTO <b>${product.name}</b>`,
        isHtml: true,
        titleIsHtml: true,
        content: `¿En realidad desea eliminar del carrito el producto <b>${product.name}</b>?`,
        showBottonCancel: true,
        textActionCancel: 'Cancelar',
        textAction: 'Aceptar'
      };
      let modalInstance = this.$uibModal.open({
        animation: true,
        template: modalConfirmation,
        controller: 'ModalResponseController',
        controllerAs: 'mdCtrl',
        size: '',
        resolve: {
          modalOptions: () => options
        }
      });
      modalInstance.result.then(() => {
        this.confirmRemoveItem(product.id, product);
      }).catch(() => {

      });
    }

  }

  confirmRemoveItem(productId, product) {
    if (this.cart.cartId) {
      this.deletingItemCart = true;
      this.deletedItemCart = false;
      this.errorDeletedItemCart = false;
      this.CartService.deleteItemFromCart(productId, this.cart.cartId).then(response => {
        this.deletingItemCart = false;
        if (!response.error) {
          this.deletedItemCart = true;
          this.updateCart();
          if(!response.pesoMinimoValidoBodega){
            this.asignarSucursalPrincipalEliminarItem(this.cart.cartId,product)
          } else{
            if (__env.adaptative) {
              this.messageMaterial('El producto' + product.name + ' ha sido eliminado del carrito.')
            } else {
              let options = {
                title: 'Notificación',
                isHtml: true,
                content: `<div class="alert alert-success" style="margin-bottom: 10px;">
                El producto <b>${product ? product.name : ''}</b> ha sido eliminado del carrito.
              </div>`,
                size: 'sm',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
              };
              this.messageResponse(options);
            }
          }
        }
        else {
          this.errorDeletedItemCart = true;
        }
      }).catch(error => {
        this.deletingItemCart = false;
        this.deletedItemCart = false;
        this.errorDeletedItemCart = true;
      });
    }
  }

  openMap(branch) {
    let options = {
      center: {
        latitude: branch.latitude,
        longitude: branch.longitude
      },
      zoom: 15,
      pan: true
    };
    let modal_options = this.$uibModal.open({
      animation: true,
      template: modalMap,
      controller: 'ModalMapController',
      controllerAs: 'mdCtrl',
      size: '',
      resolve: {
        modalOptions: () => options
      }
    });
    modal_options.result.then(() => {

    }).catch(reason => {

    });
  }

  updateCart() {
    let cartId = this.SessionService.get('cartId') || '';
    let userId = '';
    try {
      userId = this.shCtrl.globals.currentUser.userId;
    }
    catch (e) {
    }
    let clientPriceListName = '';
    try {
      clientPriceListName = this.SessionService.get('quoteCartSeller').clientPriceList;
    } catch (e) {
    }
    this.CartService.getCart(cartId, userId, clientPriceListName, true, undefined, this.shCtrl.globals.currentClient.operatingCenter.id).then(response => {
      angular.forEach(response.items, function (value, index) {
        value.quantityToAddFromCart = value.quantity;
      });
      this.cart = response;
      this.$scope.$emit('onUpdateCart');
      if(!this.cart.cartOrderData.payment.id){
        this.orderDataForm.payment = this.cart.cartOrderData.payment.id;
      }
    }).catch(reason => {
      console.log("Error al traer el carro", reason);

    })


      ;
  }

  updateCartDescargue(descargue) {
    let cartId = this.SessionService.get('cartId') || '';
    let userId = '';

    try {
      userId = this.shCtrl.globals.currentUser.userId;
    }
    catch (e) {
    }
    let clientPriceListName = '';
    try {
      clientPriceListName = this.SessionService.get('quoteCartSeller').clientPriceList;
    } catch (e) {
    }
    this.CartService.getCart(cartId, userId, clientPriceListName, true, undefined, this.shCtrl.globals.currentClient.operatingCenter.id).then(response => {
      angular.forEach(response.items, function (value, index) {
        value.quantityToAddFromCart = value.quantity;
      });
      this.cart = response;
      // this.$scope.$emit('onUpdateCart');
      if(!response.error){
        this.actualizarCondicionPagoAutomatica();
        this.CartService.updateUnloadingService(cartId, descargue).then(response => {
          if (!response.error) {
            if(response.aplicaServicioDescargue){
              this.updateCart();
            }else{
              if(this.servicioDescargue){
                this.modalNoAplicaServicioDescargue();
                this.servicioDescargue = false;
                this.updateCart();
              }
            }
          }
        });
      }


    }).catch(reason => {
      console.log("Error al traer el carro", reason);

    })


      ;
  }

  clearCart() {
    // Delete cart
    let data = {
      'cartId': this.cart.cartId
    };
    let formaPagoActual = this.cart.id_forma_pago;
    let userId = this.shCtrl.globals.currentUser.userId;
    let cartId = this.cart.cartId;

    this.CartService.clearCart(data).then(response => {
      if (!response.error) {
        this.cart = {};
        this.SessionService.put('cartId', '');
        this.SessionService.remove('quoteCartSeller');
        this.SessionService.remove('tunnelPayMethod');
        this.$scope.$emit('onUpdateCart');
        this.orderDataForm.comment = '';
        this.updateCart();
        this.shCtrl.scrollToTop(700);
        if(response.habilitarSucursalPrincipal){
          this.vareificarCambioSucursalPrincipal();
        }
        this.CartService.getPayConditions(userId, cartId).then(response => {
          this.payConditions = response;
          let actualizarMedioPagoActual = false;
          // verificamos si el medio de pago actual no viene para la sucursal
          for (let i = 0; i < this.payConditions.length; i++) {
            let condicion = this.payConditions[i];
            if(formaPagoActual == condicion.id){
              actualizarMedioPagoActual = true;
              break;
            }
          }

          if(actualizarMedioPagoActual){
            this.savePayConditionCart(formaPagoActual);
          }else{
            this.savePayConditionCart(this.payConditions[0].id);
          }
          //this.orderDataForm.payCondition = response[0].id;
        }).catch(reason => {

        });
      }
      else {
        let options = {
          title: '',
          isHtml: false,
          content: response.message,
          size: '',
          showBottonCancel: false,
          textActionCancel: '',
          textAction: 'Aceptar'
        };
        this.messageResponse(options);
      }
    }).catch(reason => {
      let options = {
        title: '',
        isHtml: false,
        content: reason,
        size: '',
        showBottonCancel: false,
        textActionCancel: '',
        textAction: 'Aceptar'
      };
      this.messageResponse(options);
    });
  }

  messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
    
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller: 'ModalResponseController',
      controllerAs: 'mdCtrl',
      size: options.size,
      resolve: {
        modalOptions: () => options
      }
    });
    modalInstance.result.then(() => {
      if (callAcept) {
        callback();
      }
    }).catch(reason => {
      if (callCancel) {
        callbackCancel();
      }
    });
  }

  messageMaterial(text) {
    var mdToast = this.$mdToast;
    this.$mdToast.show({
      hideDelay: 7000,
      controller: function () {
        this.closeToast = function () {
          mdToast.hide();
        }

      },
      controllerAs: 'toast',
      template: '<md-toast>\n' +
        '  <span class="md-toast-text">' + text + '</span>\n' +
        '  <md-button ng-click="toast.closeToast()">\n' +
        '    Cerrar\n' +
        '  </md-button>\n' +
        '</md-toast>'
    });
  }

  countQuantitiesCartUser(quantitiesUser) {
    let cantidad = 0;

    for (let i = 0; i < quantitiesUser.length; i++) {
      let cantidadUser = parseFloat(quantitiesUser[i].quantity);
      cantidad += cantidadUser;
    }
    return cantidad;
  }

  checkPriceItems(itmesCart) {
    let invalid = false;

    for (let i = 0; i < itmesCart.length; i++) {
      let pricesItem = itmesCart[i].price;
      if (pricesItem == null || pricesItem < 1) {
        invalid = true;
        break;
      }
    }

    return invalid;
  }

  getModalidadesEntrega(cart) {
    this.CartService.getShippingModalities().then(response => {

      if (!response.error) {
        this.modalidadesEntrega = response.data;
        let idModalidadCanasta = cart.cartOrderData.shippingModeId;

        for (let i = 0; i < this.modalidadesEntrega.length; i++) {
          let modalidad = this.modalidadesEntrega[i];

          if (modalidad.id == idModalidadCanasta) {
            // Si la modalidad del carrito es entrega
            if (modalidad.tipo_modalidad == 1) {
              this.modalidadEntrega = true;
              let descargue = cart.cartOrderData.unloadingService;
              if (descargue == 1) {
                this.servicioDescargue = true;
                this.actualizarServicioDescargue();
              } else {
                this.servicioDescargue = false;
                this.actualizarServicioDescargue();
              }
            } else {
              this.modalidadRecoge = true;
              this.verificarBloqueoInicio();
            }
          }
        }

      }
    }).catch(error => {

    });
  }

  verificarBloqueSucursal(modalidadId, tipoModalidad) {
    let currentClient = this.SessionService.get('currentClient');
    let sucursalId = currentClient.operatingCenter.id;
    let allMessage = [];
    // recoge en tienda
    if (tipoModalidad == 0) {
      if (sucursalId != null) {
        // Si es recoge en tienda ponemos fecha entrega pedido
        // test
        this.changeDeliveryDateOrder = false;
        // this.changeDeliveryDateOrder = true;
        this.CartService.verifyBranchLock(sucursalId).then(response => {
          if (!response.error) {
            // Si es opl
            if (response.principal) {
              if (response.bloqueoSucursal) {
                this.modalidadRecoge = false;
                let message = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_INFORMATIVO_BLOQUEO_RETIRO;
                allMessage.push(message);
                this.showModalMessageBlock(allMessage);
              } else {
                this.actualizarModalidadEnvio(modalidadId);
              }
            } else { // Si es planta
              if (response.bloqueoSucursal) {
                this.modalidadRecoge = false;
                let message = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_INFORMATIVO_BLOQUEO_RETIRO;
                allMessage.push(message);
                let validacionRetiroMensaje = this.ngAuthSettings.site.info.company.validacionRetiroTiendaMensaje;

                if (validacionRetiroMensaje) {
                  let cartId = this.cart.cartId;
                  let userId = this.shCtrl.globals.currentUser.userId;
                  this.CartService.getMaximumMainVolume(cartId, userId).then(responseMaximun => {
                    if(!responseMaximun.error){
                      if(responseMaximun.contienePrincipal){
                        let messageRetiro = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_MOSTRAR_CANTIDAD_MAXIMA_OPL;
                        messageRetiro = messageRetiro.replace("#capacidad_maxima_bodega_anterior#", responseMaximun.pesoMaximoBodega)
                        allMessage.push(messageRetiro);
                        this.showModalMessageBlock(allMessage);
                      }else{
                        this.showModalMessageBlock(allMessage);
                      }
                    }
                  });
                } else {
                  this.showModalMessageBlock(allMessage);
                }
              } else {
                this.actualizarModalidadEnvio(modalidadId);
              }
            }
          }
        });
      }
    } else {
      this.transporteUltracem = 0;
      this.transportePropio = 0;
      this.actualizarModalidadEnvio(modalidadId);
    }
  }

  actualizarModalidadEnvio(modalidadId) {
    let cartId = this.shCtrl.cart.cartId;

    let idModalidad = 0;

    if( (angular.isDefined(this.modalidadEntrega) && this.modalidadEntrega == true) || (angular.isDefined(this.modalidadRecoge) && this.modalidadRecoge == true)){
       idModalidad = modalidadId;
    }else{
       idModalidad = 0;
    }
    this.CartService.updateShippingMode(cartId, idModalidad).then(response => {
      if (!response.error) {
        this.servicioDescargue = false;
        this.actualizarServicioDescargue();
        this.getPromesaEntrega();
      }
      else {
        let options = {
          title: response.title?response.title:'No fue posible actualizar la modalidad',
          isHtml: true,
          content: response.message,
          size: '',
          showBottonCancel: false,
          textActionCancel: '',
          textAction: 'Aceptar'
        };
        this.messageResponse(options);
        this.actualizarServicioDescargue();
      }
    });
  }
  actualizarServicioDescargue() {
    let descargue;
    let cartId = this.shCtrl.cart.cartId;

    if (this.servicioDescargue) {
      descargue = 1;
    } else {
      descargue = 0;
    }
    this.CartService.updateUnloadingService(cartId, descargue).then(response => {
      if (!response.error) {
        if(response.aplicaServicioDescargue){
          this.updateCartDescargue(descargue);
        }else{
          if(this.servicioDescargue){
            this.modalNoAplicaServicioDescargue();
            this.actualizarCondicionPagoAutomatica();
            this.servicioDescargue = false;
            this.updateCart();
          }
        }
      }
    });

  }

  actualizarTransportePropio() {
    let transportePropio;
    let cartId = this.shCtrl.cart.cartId;

    if (this.transportePropio) {
      transportePropio = 1;
    } else {
      transportePropio = 0;
    }
    this.CartService.updateOwnTransport(cartId, transportePropio).then(response => {
      if (!response.error) {
        this.actualizarCondicionPagoAutomatica();
      }
    });
  }

  actualizarTransporteUltracem() {
    let transporteUltracem;
    let cartId = this.shCtrl.cart.cartId;

    if (this.transporteUltracem) {
      transporteUltracem = 1;
    } else {
      transporteUltracem = 0;
    }
    this.CartService.updateUltracemTransport(cartId, transporteUltracem).then(response => {
      if (!response.error) {
        this.actualizarCondicionPagoAutomatica();
      }
    });
  }

  getPromesaEntrega() {
    let cartId = this.shCtrl.cart.cartId;

    if (cartId != null) {
      this.CartService.getDeliveryPromise(cartId).then(response => {
        if (!response.error) {
          this.promiseDeliveryDays = response.data.promesa_entrega_dias;
          // inicializamos el minimo en adaptativo con la promesa de entrega
          let currentDate = new Date();
          this.inicializarDatePiker();
        }
      });
    }
  }

  showMessageDeliveryDays() {
    let mensaje = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_FECHA_ENTREGA_PEDIDO;
    let options = {
      title: 'Fecha de entrega del pedido',
      isHtml: true,
      content: mensaje,
      size: '',
      showBottonCancel: false,
      textActionCancel: '',
      textAction: 'Aceptar'
    };
    return this.messageResponse(options);
  }

  showMessageHolyDays() {
    let mensaje = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_FECHA_SELECCIONADA_NO_HABIL;;
    let options = {
      title: 'Fecha de entrega del pedido',
      isHtml: true,
      content: mensaje,
      size: '',
      showBottonCancel: false,
      textActionCancel: '',
      textAction: 'Aceptar'
    };
    return this.messageResponse(options);
  }

  actualizarFechaEntregaPedido() {
    let currentClient  = this.SessionService.get('currentClient');
    let idSucursal = currentClient.operatingCenter.id;
    let fechaValidar = this.deliveryDateOrder;
    fechaValidar = fechaValidar.toISOString().slice(0, 10);

    this.CartService.validateHoliday(idSucursal, fechaValidar).then(response => {
      if (!response.error) {
        if (response.esDiaFeriado) {
          this.deliveryDateOrder = '';
          this.showMessageHolyDays();
        }
      }
    })
  }

  actualizarFechaRecogePedido() {
    let currentClient  = this.SessionService.get('currentClient');
    let idSucursal = currentClient.operatingCenter.id;
    let fechaValidar = this.deliveryDateOrderPickUp;
    fechaValidar = fechaValidar.toISOString().slice(0, 10);

    this.CartService.validateHoliday(idSucursal, fechaValidar).then(response => {
      if (!response.error) {
        if (response.esDiaFeriado) {
          this.deliveryDateOrderPickUp = '';
          this.showMessageHolyDays();
        }
      }
    })
  }

  showMessagePayConditions(){
    let mensaje = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_AUTOMATICO_CONDICION_PAGO;
    let options = {
      title: 'Codición de pago',
      isHtml: true,
      content: mensaje,
      size: '',
      showBottonCancel: false,
      textActionCancel: '',
      textAction: 'Aceptar'
    };
    return this.messageResponse(options);
  }

  actualizarCondicionPagoAutomatica(){
    let respuesta = false;
    let sellerId = this.shCtrl.globals.currentUser.sellerId;
    let userId = this.shCtrl.globals.currentUser.userId;

    this.CartService.updatePayConditionAuto(this.SessionService.get('cartId')).then(response => {
      if(!response.error){
        let data = JSON.parse(response.data)[0];
        this.orderDataForm.payCondition = data.id.toString();
        this.showMessagePayConditions();
        this.updateCart();
      }

      try{
        let sellerId = this.shCtrl.globals.currentUser.sellerId;
        let userId = this.shCtrl.globals.currentUser.userId;
        let sucursalId = this.shCtrl.CartService.SessionService.branches[0].id;
        this.GetMediosPago(sellerId, userId, sucursalId);
      } catch(e){
        console.log(e);
        console.log(this.shCtrl);
      }

    }).catch(e =>{
      console.log(e);
    });
  }

  modalNoAplicaServicioDescargue() {
    let mensaje = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_INFORMATIVO_SUCURSAL_NO_HABILITA_DESCARGUE;

    let options = {
      title: 'No es posible continuar con el pedido...',
      isHtml: true,
      content: mensaje,
      size: '',
      showBottonCancel: false,
      textActionCancel: '',
      textAction: 'Aceptar'
    };
    return this.messageResponse(options);
  }

  getDebtsToPayClient() {

    try {
      let data = {
        idCia: 1,
        nit: this.shCtrl.globals.currentClient.third.documentNumber,
        idSucursal: this.shCtrl.globals.currentClient.operatingCenter.code,
        moneda: 'COP'
      };

      this.CartService.getDebtsToPay(data).then(billfoldResume => {
        this.debtsToPayResumen = billfoldResume.data;
        this.dataComandResumen = billfoldResume.dataAdicional.sistemaConcretos;
        this.lastUpdatedBillResume = this.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');

      })
      .catch(error => {
        console.log(error);
      });

    }
    catch (e) {
      // ...
    }
  }

  savePayConditionCart(payConditionId) {
    if (payConditionId) {
      this.savingPayConditionCart = true;
      this.errorUpdatingPayCondition = false;
      let data = {
        'cartId': this.shCtrl.cart.cartId,
        'payConditionId': payConditionId
      };
      this.CartService.updatePayCondition(data).then(response => {
        if (!response.error) {
          this.savingPayConditionCart = false;
          this.orderDataForm.payCondition = payConditionId;
          this.updateCart();
          /* this.actualizarCondicionPagoAutomatica(); */

          this.CartService.updatePayConditionAuto(this.SessionService.get('cartId')).then(response => {
            if(!response.error){
              this.showMessagePayConditions();
              let data = JSON.parse(response.data)[0];

              var index = this.payConditions.findIndex(x => x.id==data.id)
              if (index === -1){
                this.payConditions.push({id:""+data.id,nombre:data.nombre});
              }
              this.orderDataForm.payCondition = data.id.toString();
            }

            try{
              let sellerId = this.shCtrl.globals.currentUser.sellerId;
              let userId = this.shCtrl.globals.currentUser.userId;
              let sucursalId = this.shCtrl.CartService.SessionService.branches[0].id;
              this.GetMediosPago(sellerId, userId, sucursalId);
            } catch(e){
              console.log(e);
              console.log(this.shCtrl);
            }

          }).catch(e =>{
            console.log(e);
          });

        }
        else {
          let options = {
            title: 'No fue posible actualizar la condicion de pago',
            isHtml: false,
            content: response.message,
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar'
          };
          this.messageResponse(options);
          this.updateCart();
          this.savingPayConditionCart = false;
          this.errorUpdatingPayCondition = true;
          this.orderDataForm.payment = this.cart.id_medio_pago;
        }
      }).catch(reason => {
        this.savingPayConditionCart = false;
        this.errorUpdatingPayCondition = true;
      });
    }
  }

  showModalMora(dataOrder) {
    dataOrder.shCtrl = this.shCtrl;
    let modal_options = this.$uibModal.open({
      animation: true,
      template: modalMora,
      controller: 'ModalMoraController',
      controllerAs: 'mdCtrl',
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
      resolve: {
        modalOptions: () => dataOrder
      }
    });
    modal_options.result.then(() => {
      this.getDebtsToPayClient();
    }).catch(reason => {

    });
  }

  cambiarSucursalVolumenItems(cart) {
    let cartId = cart.cartId
    this.CartService.getShippingMode(cartId).then(response => {
      if (response.modalidad) {
        this.setSucursalesPorModalidad(response, cartId);
      } else {
        this.obtenerSucursalSecundaria(cartId);
      }
    });
  }

  setSucursalesPorModalidad(response, cartId) {
    let idCiudad = this.shCtrl.globals.currentClient.operatingCenter.ciudad_id;
    let idUsuario = this.shCtrl.globals.currentUser.userId;
    let currentClient  = this.SessionService.get('currentClient');
    let idSucursalActual = currentClient.operatingCenter.id;
    let data = {
      'userId': idUsuario,
      'ciudadId': idCiudad
    };
    let tipoModalidad = response.modalidad.tipo_modalidad;
    // Si la modalidad es recoge
    if (tipoModalidad == 0) {
      this.CartService.getSecondaryBranch(data).then(response => {
        let idSucursalSecundaria = response.listaSucursales[0].id;
        if (idSucursalSecundaria != null) {
          if(idSucursalSecundaria != idSucursalActual){
            this.setSucursalSecundariaRecogeEntrega(idSucursalSecundaria, idUsuario);
          }
        }
      });
      this.CartService.updateDateCart(cartId).then(response => {
        return response;
      });
      // Si es a domicilio
    } else {
      this.CartService.getSecondaryBranch(data).then(response => {
        let idSucursalSecundaria = response.listaSucursales[0].id;
        let idCiudad = response.listaSucursales[0].ciudad_id;

        if (idCiudad != null && idSucursalSecundaria != null && cartId != null) {
          this.CartService.updatePromiseCart(cartId, idSucursalSecundaria, idCiudad).then(response => {
            let aplicaServicioDescargue = response.aplicaServicioDescargue;
            if (idSucursalSecundaria != null) {
              if(idSucursalSecundaria != idSucursalActual){
                this.setSucursalSecundariaTipoDomicilio(idSucursalSecundaria, idUsuario, aplicaServicioDescargue);
              }
            }
          });
        }
      });
    }
  }

  setSucursalSecundariaRecogeEntrega(idSucursal, userId) {

    let mensajeCambioSucursal = '';
    let mensajeCambioHorarioBodega = '';
    let allMessage = [];
    try {
      mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
      mensajeCambioHorarioBodega = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_HORARIO_BODEGA;
      allMessage.push(mensajeCambioSucursal);
      allMessage.push(mensajeCambioHorarioBodega);

    } catch (e) {
    }
    this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
      if (!response.error) {
        // Set the current client
        this.updateCart();
        try {
          let newCurrentClient = JSON.parse(global.localStorage.currentClient);
          newCurrentClient.operatingCenter = response.branch;
          newCurrentClient.seller = response.seller;
          this.SessionService.put('currentClient', newCurrentClient);
          this.SessionService.put('cartId', response.cartID);
          this.shCtrl.userData.globals.currentClient.operatingCenter = response.branch;
          this.shCtrl.userData.globals.currentClient.seller = response.seller;

          this.$rootScope.$broadcast('actualizarHeader', response.branch);
          this.actualizarCondicionesPagoCambioSucursal();
          this.SharedService.assignWarehouseBasketCode({ 'cartId': this.cart.cartId}).then(response =>{
            if(!response.error){
              let currentClient = this.SessionService.get('currentClient');
              let sucursalId = currentClient.operatingCenter.id;
              this.CartService.verifyBranchLock(sucursalId).then(response => {
                if (!response.error) {
                  if (response.bloqueoSucursal) {
                    let validacionRetiroMensaje = this.ngAuthSettings.site.info.company.validacionRetiroTiendaMensaje;
                    this.modalidadRecoge = false;

                    let messageBloqueoRetiro = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_INFORMATIVO_BLOQUEO_RETIRO
                    allMessage.push(messageBloqueoRetiro);

                    if(validacionRetiroMensaje){
                      let cartId = this.cart.cartId;
                      let userId = this.shCtrl.globals.currentUser.userId;
                      this.CartService.getMaximumMainVolume(cartId,userId).then(responseMaximun => {
                        if(!responseMaximun.error){
                          let messageRetiro = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_MOSTRAR_CANTIDAD_MAXIMA_OPL;
                          messageRetiro = messageRetiro.replace("#capacidad_maxima_bodega_anterior#", responseMaximun.pesoMaximoBodega)
                          allMessage.push(messageRetiro);
                          this.showModalAllMessage(allMessage);
                          this.actualizarModalidadEnvio();
                        }
                      });
                    } else{
                      this.showModalAllMessage(allMessage);
                      this.actualizarModalidadEnvio();
                    }
                  } else {
                    this.showModalAllMessage(allMessage);
                  }
                }
              });
            }
          });
        } catch (e) {
        }

      } else {
        console.log('Ocurrio un erro al cambiar la sucursal')
      }
    }).catch(reason => {
      this.state.saving = false;
      this.state.error = true;
    });
  }

  setSucursalSecundariaTipoDomicilio(idSucursal, userId, aplicaServicioDescargue) {

    let mensajeCambioSucursal = '';
    let mensajeDestinoNoDisponilble = '';
    let mensajeCambioPromesa = '';
    let allMessage = [];

    try {
      mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
      mensajeCambioPromesa = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_PROMESA;
      allMessage.push(mensajeCambioSucursal);
      allMessage.push(mensajeCambioPromesa);

      if (!aplicaServicioDescargue) {
        this.servicioDescargue = aplicaServicioDescargue;
        mensajeDestinoNoDisponilble = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_INFORMATITVO_DESTINOS_NO_DISPONIBLES;
        allMessage.push(mensajeDestinoNoDisponilble);
      }

    } catch (e) {
    }
    this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
      if (!response.error) {
        // Set the current client
        this.updateCart();
        try {
          let newCurrentClient = JSON.parse(global.localStorage.currentClient);
          newCurrentClient.operatingCenter = response.branch;
          newCurrentClient.seller = response.seller;
          this.SessionService.put('currentClient', newCurrentClient);
          this.SessionService.put('cartId', response.cartID);
          this.shCtrl.userData.globals.currentClient.operatingCenter = response.branch;
          this.shCtrl.userData.globals.currentClient.seller = response.seller;

          this.$rootScope.$broadcast('actualizarHeader', response.branch);
          this.actualizarCondicionesPagoCambioSucursal();

          this.SharedService.assignWarehouseBasketCode({ 'cartId': this.cart.cartId}).then(response =>{
            if(!response.error){
              this.getPromesaEntrega();
              this.actualizarServicioDescargueCambioSucursal();
              if (allMessage !== null) {
                this.showModalAllMessage(allMessage);
              }
            }
          });
        } catch (e) {
        }

      } else {
        console.log('ocurrio un error al cambiar de sucursal')
      }
    }).catch(reason => {
      this.state.saving = false;
      this.state.error = true;
    });
  }


  asignarSucursalPrincipal(cartId){

    let idCiudad = this.shCtrl.globals.currentClient.operatingCenter.ciudad_id;
    let idUsuario = this.shCtrl.globals.currentUser.userId;
    let data = {
      'userId': idUsuario,
      'ciudadId': idCiudad
    };
    this.CartService.getPrincipalBranchOffice(data).then(response => {
      let idSucursalSecundaria = response.listaSucursales[0].id;
      if (idSucursalSecundaria != null) {
        this.setSucursalPrincipal(idSucursalSecundaria, idUsuario);
      }
    });
    this.CartService.updateDateCart(cartId).then(response => {
      return response;
    });
  }

  setSucursalPrincipal(idSucursal, userId) {

    let mensajeCambioSucursal = '';
    let allMessage = [];
    let mensajeModalidad = '';

    if(this.modalidadEntrega){
      mensajeModalidad = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_PROMESA;
    }

    if(this.modalidadRecoge){
      mensajeModalidad = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_HORARIO_BODEGA;
    }
    try {
      mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
      allMessage.push(mensajeCambioSucursal);
      if(mensajeModalidad != ""){
        allMessage.push(mensajeModalidad);
      }
    } catch (e) {
    }
    this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
      if (!response.error) {
        // Set the current client
        this.updateCart();
        try {
          let newCurrentClient = JSON.parse(global.localStorage.currentClient);
          newCurrentClient.operatingCenter = response.branch;
          newCurrentClient.seller = response.seller;
          this.SessionService.put('currentClient', newCurrentClient);
          this.SessionService.put('cartId', response.cartID);
          this.shCtrl.userData.globals.currentClient.operatingCenter = response.branch;
          this.shCtrl.userData.globals.currentClient.seller = response.seller;

          this.$rootScope.$broadcast('actualizarHeader', response.branch);
          this.actualizarCondicionesPagoCambioSucursal();
          this.SharedService.assignWarehouseBasketCode({ 'cartId': this.cart.cartId}).then(response =>{
            if(!response.error){
              if(this.modalidadEntrega){
                // verificar servicio de descargue en sucursal principal
                this.CartService.verifyServiceDownloadWarehouse(this.cart.cartId).then(response => {
                  if(!response.error){
                    if(!response.permiteDescargue){
                      this.servicioDescargue = false;
                      let mensajeDescargue = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_INFORMATIVO_SUCURSAL_NO_HABILITA_DESCARGUE;
                      allMessage.push(mensajeDescargue);
                    }
                    this.actualizarServicioDescargueCambioSucursal();
                    if (allMessage !== null) {
                      this.showModalAllMessage(allMessage);
                    }
                  }
                });
              } else{
                if(this.modalidadRecoge) {
                  let currentClient  = this.SessionService.get('currentClient');
                  let sucursalId = currentClient.operatingCenter.id;
                  this.CartService.verifyBranchLock(sucursalId).then(response => {
                    if (!response.error) {
                      if (response.bloqueoSucursal) {
                        this.modalidadRecoge = false;
                        let messageBloqueoRetiro = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_INFORMATIVO_BLOQUEO_RETIRO
                        allMessage.push(messageBloqueoRetiro);
                        this.showModalAllMessage(allMessage);
                        this.actualizarModalidadEnvio();
                      } else{
                        this.showModalAllMessage(allMessage);
                      }
                    }
                  });
                } else {
                  if (allMessage !== null) {
                    this.showModalAllMessage(allMessage);
                  }
                }
              }
              this.getPromesaEntrega();
            }
          });
        } catch (e) {
        }

      } else {
        console.log('Ocurrio un erro al cambiar la sucursal')
      }
    }).catch(reason => {
      this.state.saving = false;
      this.state.error = true;
    });
  }


  showModalAllMessage(allMesagge) {
    let contentDynamic = 'Se realizaron las siguientes modificaciones: </br>';

    for (let i = 0; i < allMesagge.length; i++) {
      contentDynamic += `
                            <ul><li>` + allMesagge[i] + `</li></ul>`;
    }

    if (contentDynamic != '') {
      let optionsMessage = {
        title: 'Actualización de precios',
        isHtml: true,
        content: contentDynamic,
        size: '',
        showBottonCancel: false,
        textActionCancel: '',
        textAction: 'Aceptar',
        backdrop: 'static'
      };

      let modalInstance = this.$uibModal.open({
        animation: true,
        template: modalConfirmation,
        controller: 'ModalResponseController',
        controllerAs: 'mdCtrl',
        size: 'md',
        backdrop: 'static',
        resolve: {
          modalOptions: () => optionsMessage
        }
      });
      modalInstance.result.then(() => {
      }).catch(() => {

      });
    }
  }

  asignarSucursalPrincipalEliminarItem(cartId,product){

    let idCiudad = this.shCtrl.globals.currentClient.operatingCenter.ciudad_id;
    let idUsuario = this.shCtrl.globals.currentUser.userId;
    let data = {
      'userId': idUsuario,
      'ciudadId': idCiudad
    };
    this.CartService.getPrincipalBranchOffice(data).then(response => {
      let idSucursalSecundaria = response.listaSucursales[0].id;
      if (idSucursalSecundaria != null) {
        this.setSucursalPrincipalEliminarItem(idSucursalSecundaria, idUsuario, product);
      }
    });
    this.CartService.updateDateCart(cartId).then(response => {
      return response;
    });
  }

  setSucursalPrincipalEliminarItem(idSucursal, userId, product) {

    let mensajeCambioSucursal = '';
    let mensajeModalidad = '';
    let allMessage = [];
    try {
      mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;

      if(this.modalidadEntrega){
        mensajeModalidad = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_PROMESA;
      }

      if(this.modalidadRecoge){
        mensajeModalidad = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_HORARIO_BODEGA;
      }

      allMessage.push(mensajeCambioSucursal);
      if(mensajeModalidad != ''){
        allMessage.push(mensajeModalidad);
      }
    } catch (e) {
    }
    this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
      if (!response.error) {
        // Set the current client
        this.updateCart();
        try {
          let newCurrentClient = JSON.parse(global.localStorage.currentClient);
          newCurrentClient.operatingCenter = response.branch;
          newCurrentClient.seller = response.seller;
          this.SessionService.put('currentClient', newCurrentClient);
          this.SessionService.put('cartId', response.cartID);
          this.shCtrl.userData.globals.currentClient.operatingCenter = response.branch;
          this.shCtrl.userData.globals.currentClient.seller = response.seller;

          this.$rootScope.$broadcast('actualizarHeader', response.branch);
          this.actualizarCondicionesPagoCambioSucursal();
          this.SharedService.assignWarehouseBasketCode({ 'cartId': this.cart.cartId}).then(response =>{
            if(!response.error){
              if(this.modalidadEntrega){
                // verificar servicio de descargue en sucursal principal
                this.CartService.verifyServiceDownloadWarehouse(this.cart.cartId).then(response => {
                  if(!response.error){
                    if(!response.permiteDescargue){
                      this.servicioDescargue = false;
                      let mensajeDescargue = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_INFORMATIVO_SUCURSAL_NO_HABILITA_DESCARGUE;
                      allMessage.push(mensajeDescargue);
                      if (allMessage !== null) {
                        this.showModalAllMessageDeleteItem(allMessage,product);
                      }
                    } else{
                      if (allMessage !== null) {
                        this.showModalAllMessageDeleteItem(allMessage,product);
                      }
                    }
                    this.actualizarServicioDescargueCambioSucursal();
                  }
                });
              } else{
                if(this.modalidadRecoge) {
                  let currentClient  = this.SessionService.get('currentClient');
                  let sucursalId = currentClient.operatingCenter.id;
                  this.CartService.verifyBranchLock(sucursalId).then(response => {
                    if (!response.error) {
                      if (response.bloqueoSucursal) {
                        this.modalidadRecoge = false;
                        let messageBloqueoRetiro = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_INFORMATIVO_BLOQUEO_RETIRO
                        allMessage.push(messageBloqueoRetiro);
                        this.showModalAllMessage(allMessage);
                        this.actualizarModalidadEnvio();
                      } else{
                        this.showModalAllMessage(allMessage);
                      }
                    }
                  });
                } else {
                  if (allMessage !== null) {
                    this.showModalAllMessage(allMessage);
                  }
                }
              }
              this.getPromesaEntrega();
            }
          });
        } catch (e) {
        }

      } else {
        console.log('Ocurrio un erro al cambiar la sucursal')
      }
    }).catch(reason => {
      this.state.saving = false;
      this.state.error = true;
    });
  }


  showModalAllMessageDeleteItem(allMesagge,product) {
    let contentDynamic = 'Se realizaron las siguientes modificaciones: </br>';

    for (let i = 0; i < allMesagge.length; i++) {
      contentDynamic += `
                            <ul><li>` + allMesagge[i] + `</li></ul>`;
    }

    if (contentDynamic != '') {
      let optionsMessage = {
        title: 'Actualización de precios',
        isHtml: true,
        content: contentDynamic,
        size: '',
        showBottonCancel: false,
        textActionCancel: '',
        textAction: 'Aceptar',
        backdrop: 'static'
      };

      let modalInstance = this.$uibModal.open({
        animation: true,
        template: modalConfirmation,
        controller: 'ModalResponseController',
        controllerAs: 'mdCtrl',
        size: 'md',
        backdrop: 'static',
        resolve: {
          modalOptions: () => optionsMessage
        }
      });
      modalInstance.result.then(() => {
        if (__env.adaptative) {
          this.messageMaterial('El producto' + product.name + ' ha sido eliminado del carrito.')
        } else {
          let options = {
            title: 'Notificación',
            isHtml: true,
            content: `<div class="alert alert-success" style="margin-bottom: 10px;">
            El producto <b>${product ? product.name : ''}</b> ha sido eliminado del carrito.
          </div>`,
            size: 'sm',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar'
          };
          this.messageResponse(options);
        }
      }).catch(() => {

      });
    }
  }

  verificarReglaCobertura(orderData){
    let cartId = this.SessionService.get('cartId') || '';

    this.CartService.checkVolumePurchaseRule(cartId).then(response => {
      if(!response.error){
        // Si continene regla dejamos pasar al tunel
        if(response.aplicaRegla){
          this.guardarPedidoCanasta(orderData);
        }else{
          this.savingOrderCart = false;
          let options = {
            title: 'NO ES POSIBLE COMPLETAR EL PEDIDO...',
            isHtml: true,
            content: this.shCtrl.globalParams.cmsInfo.MENSAJE_BODEGA_SUCURSAL_NO_TIENE_COBERTURA,
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar'
          };
          return this.messageResponse(options);
        }
      } else{
        let options = {
          title: '',
          isHtml: false,
          content: response.message,
          size: '',
          showBottonCancel: false,
          textActionCancel: '',
          textAction: 'Aceptar'
        };
        return this.messageResponse(options);
      }
    }).catch(reason => {

      let options = {
        title: 'Ocurrio un error',
        isHtml: false,
        content: 'Ha ocurrido un error al actualizar el carrito',
        size: '',
        showBottonCancel: false,
        textActionCancel: '',
        textAction: 'Aceptar'
      };
      return this.messageResponse(options);
    });

  }

  obtenerSucursalSecundaria(cartId) {
    let idCiudad = this.shCtrl.globals.currentClient.operatingCenter.ciudad_id;
    let idUsuario = this.shCtrl.globals.currentUser.userId;
    let currentClient  = this.SessionService.get('currentClient');
    let idSucursalActual = currentClient.operatingCenter.id;
    let data = {
      'userId': idUsuario,
      'ciudadId': idCiudad
    };
    // Si la modalidad es recoge
    if (data != null) {
      this.CartService.getSecondaryBranch(data).then(response => {
        let idSucursalSecundaria = response.listaSucursales[0].id;
        if (idSucursalSecundaria != null) {
          if(idSucursalSecundaria != idSucursalActual){
            this.setSucursalSecundariaSinModalidad(idSucursalSecundaria, idUsuario);
          }
        }
      });
      this.CartService.updateDateCart(cartId).then(response => {
        return response;
      });
    }
  }

  setSucursalSecundariaSinModalidad(idSucursal, userId) {

    let mensajeCambioSucursal = '';
    let allMessage = [];
    try {
      mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
      allMessage.push(mensajeCambioSucursal);
    } catch (e) {
    }
    this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
      if (!response.error) {
        // Set the current client
        this.updateCart();
        try {
          let newCurrentClient = JSON.parse(global.localStorage.currentClient);
          newCurrentClient.operatingCenter = response.branch;
          newCurrentClient.seller = response.seller;
          this.SessionService.put('currentClient', newCurrentClient);
          this.SessionService.put('cartId', response.cartID);
          this.shCtrl.userData.globals.currentClient.operatingCenter = response.branch;
          this.shCtrl.userData.globals.currentClient.seller = response.seller;

          this.$rootScope.$broadcast('actualizarHeader', response.branch);
          this.actualizarCondicionesPagoCambioSucursal();
          this.SharedService.assignWarehouseBasketCode({ 'cartId': this.shCtrl.cart.cartId }).then(response => {
            if (!response.error) {
              if (allMessage !== null) {
                this.showModalAllMessage(allMessage);
              }
            }
          });
        } catch (e) {
        }

      } else {
        console.log('Ocurrio un erro al cambiar la sucursal')
      }
    }).catch(reason => {
      this.state.saving = false;
      this.state.error = true;
    });
  }

  vareificarCambioSucursalPrincipal() {
    let userId = this.shCtrl.globals.currentUser.userId;
    let idCiudad = this.shCtrl.globals.currentClient.operatingCenter.ciudad_id;
    let data = {
      'userId': userId,
      'ciudadId': idCiudad
    };

    this.CartService.getPrincipalBranchOffice(data).then(responseSucursal => {
      if (responseSucursal.sucursalesPrincipales) {

        let currentClient  = this.SessionService.get('currentClient');
        let idSucursalSeleccionada  = currentClient.operatingCenter.id;

        let idSucursalPrincipal = "";
        if (responseSucursal.listaSucursales.length > 1) {
          idSucursalPrincipal = this.buscarSucursalPrincipal(responseSucursal.listaSucursales);

          if (idSucursalSeleccionada != idSucursalPrincipal) {
            this.setSucursalPrincipal(idSucursalPrincipal, userId);
          }
        } else {
          idSucursalPrincipal = responseSucursal.listaSucursales[0].id;
          if (idSucursalSeleccionada != idSucursalPrincipal) {
            this.setSucursalPrincipal(idSucursalPrincipal, userId);
          }
        }
      }
    });
  }

  buscarSucursalPrincipal(listaSucursales) {
    let sucursalCiudad = this.shCtrl.globals.currentClient.operatingCenter.ciudad_id;
    let idSucursalPrincipal;

    // Buscamos la sucursal que contenga el mismo id de la ciudad de la sucursal almacenada
    for (let i = 0; i < listaSucursales.length; i++) {
      let sucursal = listaSucursales[i];
      if (sucursal.ciudad_id == sucursalCiudad) {
        idSucursalPrincipal = sucursal.id;
        break;
      }
    }

    return idSucursalPrincipal;
  }

  GetMediosPago(sellerId, userId, sucursalId){
    this.CartService.getPayMethods(sellerId, userId, sucursalId,this.SessionService.get('cartId')).then(response => {
        this.loadedPayMethods = true;
        this.payMethods = response;
        if (response.length === 1) {
           this.orderDataForm.payment = response[0].id;
        }
    });
  }

  // verificar modal mora
  verificarModalMora(orderDataForm){
    try {
      let data = {
          idCia: 1,
          nit: this.shCtrl.globals.currentClient.third.documentNumber,
          idSucursal: this.shCtrl.globals.currentClient.operatingCenter.code,
          moneda: 'COP'
      };
      let validaVolumen = this.ngAuthSettings.site.info.company.validacionVolumenCompra;
      this.orderDataForm.loadingStatusDebtsToPay = true;
      this.CartService.getDebtsToPay(data).then(billfoldResume => {
        this.orderDataForm.loadingStatusDebtsToPay = false;
        let billResume = billfoldResume.data;

        // Si aplica mora mostramos el modal
        if(billResume.cartera_vencida > 0){
          this.showModalMora(orderDataForm);
        } else if(validaVolumen){
          this.CartService.checkVolumePurchaseRule(this.cart.cartId).then(response => {
            if(!response.error){
              // Si continene regla dejamos pasar al tunel
              if(response.aplicaRegla){
                this.guardarPedidoCanasta(orderDataForm);
              }else{
                this.savingOrderCart = false;
                let options = {
                  title: 'NO ES POSIBLE COMPLETAR EL PEDIDO...',
                  isHtml: true,
                  content: this.shCtrl.globalParams.cmsInfo.MENSAJE_BODEGA_SUCURSAL_NO_TIENE_COBERTURA,
                  size: '',
                  showBottonCancel: false,
                  textActionCancel: '',
                  textAction: 'Aceptar'
                };
                return this.messageResponse(options);
              }
            } else{
              let options = {
                title: '',
                isHtml: false,
                content: response.message,
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
              };
              return this.messageResponse(options);
            }
          });
        } else{
          this.guardarPedidoCanasta(orderDataForm);
        }
      }).catch(error => {
        console.log(error);
        this.orderDataForm.loadingStatusDebtsToPay = false;
      });
    }
    catch (e) {
      // ...
    }
  }

  cambiarFechaEntregaPedido(){
    if(!this.changeDeliveryDateOrder){
      this.deliveryDateOrder = '';
    }
  }

  showModalMessageBlock(allMesagge) {
    let contentDynamic = 'Se realizaron las siguientes modificaciones: </br>';

    for (let i = 0; i < allMesagge.length; i++) {
      contentDynamic += `
                            <ul><li>` + allMesagge[i] + `</li></ul>`;
    }

    if (contentDynamic != '') {
      let optionsMessage = {
        title: 'No es posible continuar con el pedido',
        isHtml: true,
        content: contentDynamic,
        size: '',
        showBottonCancel: false,
        textActionCancel: '',
        textAction: 'Aceptar',
        backdrop: 'static'
      };

      let modalInstance = this.$uibModal.open({
        animation: true,
        template: modalConfirmation,
        controller: 'ModalResponseController',
        controllerAs: 'mdCtrl',
        size: 'md',
        backdrop: 'static',
        resolve: {
          modalOptions: () => optionsMessage
        }
      });
      modalInstance.result.then(() => {
      }).catch(() => {

      });
    }
  }

  verificarBloqueoInicio() {
    let currentClient = this.SessionService.get('currentClient');
    let sucursalId = currentClient.operatingCenter.id;
    let allMessage = [];
    let transportePropio = this.cart.cartOrderData.ownTransport;
    let transporteUltracem = this.cart.cartOrderData.ultracemTransport;

    this.CartService.verifyBranchLock(sucursalId).then(response => {
      if (!response.error) {
        // Si es opl
        if (response.principal) {
          if (response.bloqueoSucursal) {
            this.modalidadRecoge = false;
            let message = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_INFORMATIVO_BLOQUEO_RETIRO;
            allMessage.push(message);
            this.showModalMessageBlock(allMessage);
          } else {
            if (transportePropio == 1) {
              this.transportePropio = true;
              this.transporteUltracem = false;
            }

            if (transporteUltracem == 1) {
              this.transporteUltracem = true;
              this.transportePropio = false;
            }
          }
        } else { // Si es planta
          if (response.bloqueoSucursal) {
            this.modalidadRecoge = false;
            let message = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_INFORMATIVO_BLOQUEO_RETIRO;
            allMessage.push(message);
            let validacionRetiroMensaje = this.ngAuthSettings.site.info.company.validacionRetiroTiendaMensaje;

            if (validacionRetiroMensaje) {
              let cartId = this.cart.cartId;
              let userId = this.shCtrl.globals.currentUser.userId;
              this.CartService.getMaximumMainVolume(cartId, userId).then(responseMaximun => {
                if (!responseMaximun.error) {
                  if (responseMaximun.contienePrincipal) {
                    let messageRetiro = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_MOSTRAR_CANTIDAD_MAXIMA_OPL;
                    messageRetiro = messageRetiro.replace("#capacidad_maxima_bodega_anterior#", responseMaximun.pesoMaximoBodega)
                    allMessage.push(messageRetiro);
                    this.showModalMessageBlock(allMessage);
                  } else {
                    this.showModalMessageBlock(allMessage);
                  }
                }
              });
            } else {
              this.showModalMessageBlock(allMessage);
            }
          } else {
            if (transportePropio == 1) {
              this.transportePropio = true;
              this.transporteUltracem = false;
            }

            if (transporteUltracem == 1) {
              this.transporteUltracem = true;
              this.transportePropio = false;
            }
          }
        }
      }
    });
  }

  actualizarServicioDescargueCambioSucursal() {
    let descargue;
    let cartId = this.shCtrl.cart.cartId;

    if (this.servicioDescargue) {
      descargue = 1;
    } else {
      descargue = 0;
    }
    this.CartService.updateUnloadingService(cartId, descargue).then(response => {
      if (!response.error) {
        if(response.aplicaServicioDescargue){
          this.updateCartDescargue(descargue);
        }else{
          if(this.servicioDescargue){
            this.actualizarCondicionPagoAutomatica();
            this.servicioDescargue = false;
            this.updateCart();
          }
        }
      }
    });

  }

  actualizarCondicionesPagoCambioSucursal(){
    let cartId = this.shCtrl.cart.cartId;
    let userId = this.shCtrl.globals.currentUser.userId;
    let formaPagoActual = this.cart.id_forma_pago;
    let realizaCambioMetodoPago = true;
    this.CartService.getPayConditions(userId, cartId).then(response => {
      this.payConditions = response;
      // verificamos si el medio de pago actual no viene para la sucursal
      for (let i = 0; i < this.payConditions.length; i++) {
        let condicion = this.payConditions[i];
        if(formaPagoActual == condicion.id){
          realizaCambioMetodoPago = false;
          break;
        }
      }

      if(realizaCambioMetodoPago){
        this.savePayConditionCart(this.payConditions[0].id);
      }
      //this.orderDataForm.payCondition = response[0].id;
    }).catch(reason => {

    });
  }
}

CartController.$inject = inject;

export default CartController;




/** WEBPACK FOOTER **
 ** ./www/components/cart/cart.controller.js
 **/